module.exports = __webpack_public_path__ + "static/media/user_review.355fb1dc.png";